import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e07228a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "waring" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tr" }, "请谨慎操作"),
  /*#__PURE__*/_createElementVNode("div", { class: "tr" }, "1、删除用户后，该用户的所有信息将无法找回，数据不能恢复。"),
  /*#__PURE__*/_createElementVNode("div", { class: "tr" }, "2、删除用户后，该用户不能再登录系统。"),
  /*#__PURE__*/_createElementVNode("div", { class: "tr" }, "3、因为操作不当引起的系统问题，平台概不负责。")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px"} }, "请输入 “确认删除”", -1))
const _hoisted_3 = { class: "dialog-footer" }

import { reactive, ref,   } from "vue";
import type { FormInstance, } from "element-plus";

// const { proxy } = getCurrentInstance()
// import { usersPhone } from "@/api/uesrs";


export default /*#__PURE__*/_defineComponent({
  __name: 'dialog-delete',
  props: {
    visible: { type: Boolean, default: false }
  },
  emits: ['closed', 'confirm'],
  setup(__props: any, { emit }) {

const props = __props;





// 删除表单部分
const deleteForm = reactive({
  desc: ''
})
const deletRef = ref<FormInstance>()
const deletRules = {
  desc: [{ required: true, message: '请输入确认删除', trigger: 'blur' },
  { pattern: /^确认删除$/, message: '内容不正确', trigger: 'blur' },
  ]
}


/**
* 取消 重置表单
*/
const resetForm = (form: FormInstance | undefined) => {
  if (!form) return
  form.resetFields()
  emit('closed')
}

/**
* 确定 重置表单
*/
const handelDelete = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      emit('confirm', deleteForm);
      resetForm(formEl)
    } else {
      console.log('error submit!', fields)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: props.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.visible) = $event)),
    title: "删除用户",
    width: "500",
    "destroy-on-close": "",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (resetForm(deletRef.value))),
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (resetForm(deletRef.value))),
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handelDelete(deletRef.value))),
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_form, {
        model: deleteForm,
        ref_key: "deletRef",
        ref: deletRef,
        rules: deletRules
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_el_form_item, {
            label: "",
            prop: "desc"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: deleteForm.desc,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deleteForm.desc) = $event)),
                autocomplete: "off",
                placeholder: "请输入确认删除"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})